import { render, staticRenderFns } from "./clientOverview_listActivities.vue?vue&type=template&id=4e054bd4&scoped=true&"
import script from "./clientOverview_listActivities.vue?vue&type=script&lang=js&"
export * from "./clientOverview_listActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e054bd4",
  null
  
)

export default component.exports